export default __webpack_public_path__ + "static/media/brittany_sincox.2696bcb5.png";